'use client';

import { c as _c } from "react/compiler-runtime";
import { errorCodeOf } from '@/lib/orpc/errors';
import { ErrorDataUnavailable, type ErrorDataUnavailableProps } from '../ErrorDataUnavailable';
import { NOT_SUPPORTED_SECTION_DESCRIPTION, NOT_SUPPORTED_TITLE } from '../notSupported.constants';
export interface TableQueryErrorProps extends Pick<ErrorDataUnavailableProps, 'minHeight' | 'className' | 'style'> {
  error: unknown;
}

/** Query error state for list tables: an unsupported chain is an expected state, not a connectivity failure. */
const TableQueryError = t0 => {
  const $ = _c(9);
  const {
    error,
    minHeight,
    className,
    style
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = errorCodeOf(error);
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const notSupported = t1 === "NOT_FOUND";
  const t2 = notSupported ? NOT_SUPPORTED_TITLE : undefined;
  const t3 = notSupported ? NOT_SUPPORTED_SECTION_DESCRIPTION : undefined;
  const t4 = !notSupported;
  let t5;
  if ($[2] !== className || $[3] !== minHeight || $[4] !== style || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <ErrorDataUnavailable title={t2} description={t3} showActions={t4} minHeight={minHeight} className={className} style={style} />;
    $[2] = className;
    $[3] = minHeight;
    $[4] = style;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default TableQueryError;